<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="saveAlbum">
      <template v-slot:header> Album </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <base-label>Date</base-label>
            <el-date-picker
              v-model="album.date"
              type="date"
              placeholder="Select a date"
              class="w-full"
              format="MM/dd/yyyy"
              value-format="MM/dd/yyyy"
              @change="updateAlbumName"
            >
            </el-date-picker>
          </div>
          <div>
            <base-label>Time Of Day</base-label>
            <el-select
              v-model="album.time_of_day"
              placeholder="Select"
              class="w-full"
              @change="updateAlbumName"
            >
              <el-option
                v-for="(time_of_day, index) in timesOfDay"
                :key="index"
                :label="time_of_day"
                :value="time_of_day"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <base-label>Outfitter</base-label>
            <el-select
              v-model="album.outfitter_id"
              filterable
              placeholder="Select"
              class="w-full"
              @change="updateAlbumName"
            >
              <el-option
                v-for="outfitter in outfitters"
                :key="outfitter.id"
                :label="outfitter.name"
                :value="outfitter.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <base-label>Photographer</base-label>
            <el-select
              v-model="album.photographer_id"
              filterable
              placeholder="Select"
              class="w-full"
            >
              <el-option
                v-for="photographer in photographers"
                :key="photographer.id"
                :label="photographer.name"
                :value="photographer.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <base-label>River Section</base-label>
            <el-select
              v-model="album.river_section_id"
              filterable
              placeholder="Select"
              class="w-full"
              @change="updateAlbumName"
            >
              <el-option
                v-for="riverSection in riverSections"
                :key="riverSection.id"
                :label="
                  riverSection.river.name.concat(' - ', riverSection.name)
                "
                :value="riverSection.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-span-2">
            <base-label>Album Name</base-label>
            <base-input v-model="album.name" />
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseLabel from "@/components/ui/forms/BaseLabel";
import clone from "lodash/cloneDeep";
export default {
  name: "Album",
  props: {
    originalAlbum: {},
    showModal: Boolean,
  },
  components: {
    BaseLabel,
  },
  data() {
    return {
      album: {
        id: null,
        date: null,
        time_of_day: null,
        river_section_id: null,
        outfitter_id: null,
        photographer_id: null,
        name: null,
      },
      timesOfDay: ["Morning", "Afternoon", "Full Day"],
    };
  },
  watch: {
    originalAlbum: function (newVal) {
      this.album = newVal;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    updateAlbumName() {
      const outfitter = this.album.outfitter_id
        ? this.outfitters.find(
            (outfitter) => outfitter.id == this.album.outfitter_id
          )
        : null;
      const riverSection = this.album.river_section_id
        ? this.riverSections.find(
            (riverSection) => riverSection.id === this.album.river_section_id
          )
        : null;

      this.album.name = "";
      this.album.name += this.album.date ? this.album.date + "|" : "";
      this.album.name += outfitter ? outfitter.name + "|" : "";
      this.album.name += riverSection ? riverSection.river.name + "|" : "";
      this.album.name += riverSection ? riverSection.name + "|" : "";
      this.album.name += this.album.time_of_day ? this.album.time_of_day : "";
    },
    saveAlbum() {
      if (
        !this.album.date ||
        !this.album.time_of_day ||
        !this.album.outfitter_id ||
        !this.album.river_section_id ||
        !this.album.name ||
        !this.album.photographer_id
      ) {
        this.$notify({
          title: "New Album",
          message: "All fields are required",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("queue/save_album", this.album).then((resp) => {
        if (!resp.success) return;

        this.$notify({
          title: "Album",
          message: "Album Saved",
          type: "success",
        });
        this.$emit("save", resp.album);
      });
    },
  },
  computed: {
    outfitters: function () {
      let outfitters = this.$store.getters["outfitter/getOutfitters"];
      const user = this.$store.getters["auth/getUser"];
      if (user.outfitter_id) {
        outfitters = outfitters.filter(
          (outfitter) => outfitter.id === user.outfitter_id
        );
      }
      return outfitters;
    },
    photographers: function () {
      return this.$store.getters["photographer/getPhotographers"];
    },
    riverSections: function () {
      if (!this.album.outfitter_id)
        return this.$store.getters["riverSection/getRiverSections"];

      const outfitter = this.outfitters.find(
        (outfitter) => outfitter.id === this.album.outfitter_id
      );
      return outfitter.river_sections;
    },
  },
  mounted() {
    this.album = clone(this.originalAlbum);
  },
};
</script>

<style scoped></style>
